import React, { useState } from 'react';
import { WilayaSelector } from './WilayaSelector';
import { CommuneSelector } from './CommuneSelector';
import { FormField } from '../properties/forms/components/FormField';
import { FormRow } from '../properties/forms/components/FormRow';

interface LocationSelectorProps {
  wilayaName: string;
  wilayaValue: string;
  communeName: string;
  communeValue: string;
  onWilayaChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCommuneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export const LocationSelector: React.FC<LocationSelectorProps> = ({
  wilayaName,
  wilayaValue,
  communeName,
  communeValue,
  onWilayaChange,
  onCommuneChange,
  className = "",
}) => {
  const [selectedWilayaCode, setSelectedWilayaCode] = useState<string>('');

  const handleWilayaSelect = (wilayaCode: string) => {
    console.log('🏛️ LocationSelector - Wilaya sélectionnée:', wilayaCode);
    setSelectedWilayaCode(wilayaCode);
    
    // Réinitialiser la commune quand on change de wilaya
    onCommuneChange({
      target: {
        name: communeName,
        value: '',
        type: 'text'
      }
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <FormRow className={className}>
      <FormField label="Wilaya">
        <WilayaSelector
          name={wilayaName}
          value={wilayaValue}
          onChange={onWilayaChange}
          onWilayaSelect={handleWilayaSelect}
          placeholder="Tapez le code ou le nom"
        />
      </FormField>

      <FormField label="Commune/Ville">
        <CommuneSelector
          name={communeName}
          value={communeValue}
          onChange={onCommuneChange}
          wilayaCode={selectedWilayaCode}
          placeholder={selectedWilayaCode ? "Saisir une commune" : "Sélectionnez d'abord une wilaya"}
          allowCustom={true}
        />
      </FormField>
    </FormRow>
  );
};